<template>
  <v-container fluid class="marketproject-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-project`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Project
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-campaigns`"
          >
            <v-icon class="mr-3">mdi-view-list</v-icon>
            Campaigns
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-teams`"
          >
            <v-icon class="mr-3">mdi-account-group</v-icon>
            Team
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>

          <v-tab-item
            :value="'tab-project'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="9"><p class="text-h5">Edit Project</p></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="onChangeProject($event, 'projectnum')"
                        v-bind:value="initvalue.projectnum"
                        placeholder="Project Num"
                        persistent-hint
                        single-line hint="Enter the project num">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=marketprojecttype
                        v-on:change="onChangeProject($event, 'projecttype')"
                        v-bind:value="initvalue.projecttype"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the project type">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeProject($event, 'projectname')"
                        v-bind:value="initvalue.projectname"
                        placeholder="Project Name"
                        persistent-hint
                        single-line hint="Enter the project name">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="pages.map(x => {return {text: x.pagename, value: x._id};})"
                        v-on:change="onChangeProject($event, 'pageid')"
                        v-bind:value="initvalue.pageid"
                        outlined
                        dense
                        placeholder="Page"
                        persistent-hint
                        single-line hint="Please choose the page">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeProject($event, 'ad_account_id')"
                        v-bind:value="initvalue.ad_account_id"
                        placeholder="Ad Account Id"
                        persistent-hint
                        single-line hint="Enter the ad account id">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="locations.filter(location=>location.locationstatus=='Active').map(x => {return {text: x.locationname, value: x._id};})"
                        v-on:change="onChangeProject($event, 'locationid')"
                        v-bind:value="initvalue.locationid"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>


                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="brands.filter(brand=>brand.brandstatus=='Active' && brand.brandtype=='Brand').map(x => {return {text: x.brandname, value: x._id}})"
                        v-on:change="onChangeProject($event, 'brandid')"
                        v-bind:value="initvalue.brandid"
                        outlined
                        dense
                        placeholder="Brand"
                        persistent-hint
                        single-line hint="Please choose the brand">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="data_users.filter(user=>user.userstatus=='Active').map(x => {return {text: `${x.username} (${x.companycode})`, value: x._id}})"
                        v-on:change="onChangeProject($event, 'repid')"
                        v-bind:value="initvalue.repid"
                        outlined
                        dense
                        placeholder="Marketing Rep"
                        persistent-hint
                        single-line hint="Please choose the marketing rep">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="data_users.filter(user=>user.userstatus=='Active').map(x => {return {text: `${x.username} (${x.companycode})`, value: x._id}})"
                        v-on:change="onChangeProject($event, 'approverid')"
                        v-bind:value="initvalue.approverid"
                        outlined
                        dense
                        placeholder="Approver"
                        persistent-hint
                        single-line hint="Please choose the approver">
                      </v-select>

                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Active', 'Inactive']"
                        :value="initvalue.projectstatus"
                        outlined
                        dense
                        v-on:change="onChangeProject($event, 'projectstatus')"
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the status">
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                        <v-btn
                            @click="Done"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="updateMarketProject()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-campaigns'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="6">
                        <p class="text-h5">Campaigns</p>
                      </v-col>
                      <v-col md="6" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddCampaign = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="success"
                          @click="Done"
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="header_campaigns"
                        :items="data_campaigns"
                        :items-per-page="500"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteCampaign" width="500">
                            <v-card>
                              <v-card-title> Delete this Campaign? </v-card-title>
                              <v-card-text>
                                {{ delete_campaign.membername }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteCampaign = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteProjectMember(delete_campaign)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.campaignobjective="{ item }">
                          <p class="two-line">{{ item.campaignobjective }}</p>
                        </template>
                        <template v-slot:item.optimization_goal="{ item }">
                          <p class="two-line">{{ item.optimization_goal }}</p>
                          <p class="two-line">{{ item.billing_event }}</p>
                        </template>
                        <template v-slot:item.memberimage="{ item }">
                          <v-img
                            v-if="item.memberimage" 
                            v-bind:src="item.memberimage"
                            max-height="100"
                            max-width="100"
                          ></v-img>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editProjectCampaignDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteProjectCampaignDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-teams'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="6">
                        <p class="text-h5">Team Members</p>
                      </v-col>
                      <v-col md="6" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddMember = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="success"
                          @click="Done"
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="memberrank"
                        :headers="header_members"
                        :items="data_members"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteMember" width="500">
                            <v-card>
                              <v-card-title> Delete this Member? </v-card-title>
                              <v-card-text>
                                {{ delete_member.membername }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteMember = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteProjectMember(delete_member)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.membername="{ item }">
                          <p class="two-line">{{ item.membername }}</p>
                          <p class="two-line">{{ item.membertype }}</p>
                        </template>
                        <template v-slot:item.memberimage="{ item }">
                          <v-img
                            v-if="item.memberimage" 
                            v-bind:src="item.memberimage"
                            max-height="100"
                            max-width="100"
                          ></v-img>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editProjectMemberDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteProjectMemberDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            @click="Done"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div justify="center">
    <v-dialog
      v-model="isAddMember"
      persistent
      width="500px"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Member</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="add_member.memberrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="9">
                <v-select
                  class="mb-4"
                  :items="data_users.filter(user=>user.userstatus=='Active').map(x => {
                    return {text: `${x.username} (${x.companycode})`, value: x._id};
                  })"
                  v-on:change="selectUser"
                  v-model="add_member.userid"
                  v-bind:error="errorindex == 3"
                  placeholder="User"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-switch
                  color="primary"
                  v-bind:label="add_member.isLead==true ? 'On': ''"
                  v-model="add_member.isLead"
                  :value="true"
                  :false-value="false"
                  hint="Team Lead"
                  persistent-hint
                ></v-switch>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field
                  v-model="add_member.membername"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddMember=false; add_member={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addProjectMemberRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isEditMember"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Member</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeMember($event, 'memberrank')"
                  :value="edit_member.memberrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="5">
                <!-- <v-select
                  class="mb-4"
                  :items="teamsubgroups.map(x => {
                    return {text: x.subgroupcode, value: x._id};
                  })"
                  v-on:change="onChangeMember($event, 'subgroupid')"
                  :value="edit_member.subgroupid"
                  placeholder="Subgroup"
                  dense
                >
                </v-select> -->
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeMember($event, 'membername')"
                  :value="edit_member.membername"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeMember($event, 'membercode')"
                  :value="edit_member.membercode"
                  label="Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeMember($event, 'membericon')"
                  :value="edit_member.membericon"
                  label="Icon"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="onChangeMember($event, 'memberlink')"
                  :value="edit_member.memberlink"
                  label="Link"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="onChangeMember($event, 'memberaction')"
                  :value="edit_member.memberaction"
                  label="Action"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditMember=false; edit_member={};"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editProjectMemberRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isAddCampaign"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Campaign</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="add_campaign.campaignname"
                  label="Name"
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  class="mb-4"
                  :items="['Engage', 'Reach', 'Traffic']"
                  v-model="add_campaign.campaigntype"
                  placeholder="Type"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="['OUTCOME_ENGAGEMENT', 'OUTCOME_AWARENESS', 'OUTCOME_TRAFFIC']"
                  v-model="add_campaign.campaignobjective"
                  placeholder="Objective"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  class="mb-4"
                  :items="['POST_ENGAGEMENT', 'REACH']"
                  v-model="add_campaign.optimization_goal"
                  placeholder="Optimization"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  class="mb-4"
                  :items="['IMPRESSIONS']"
                  v-model="add_campaign.billing_event"
                  placeholder="Billing"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="add_campaign.targeting"
                  rows=5
                  label="Targeting"
                  hint="please enter campaign targeting"
                  dense
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddCampaign=false; add_campaign={};"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addProjectCampaignRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isEditCampaign"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Campaign</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeCampaign($event, 'campaignname')"
                  :value="edit_campaign.campaignname"
                  label="Name"
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  class="mb-4"
                  :items="['Engage', 'Reach', 'Traffic']"
                  v-on:change="onChangeCampaign($event, 'campaigntype')"
                  :value="edit_campaign.campaigntype"
                  placeholder="Type"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="['OUTCOME_ENGAGEMENT', 'OUTCOME_AWARENESS', 'OUTCOME_TRAFFIC']"
                  v-on:change="onChangeCampaign($event, 'campaignobjective')"
                  :value="edit_campaign.campaignobjective"
                  placeholder="Objective"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  class="mb-4"
                  :items="['POST_ENGAGEMENT', 'REACH']"
                  v-on:change="onChangeCampaign($event, 'optimization_goal')"
                  v-model="edit_campaign.optimization_goal"
                  :value="edit_campaign.optimization_goal"
                  placeholder="Optimization"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  class="mb-4"
                  :items="['IMPRESSIONS']"
                  v-on:change="onChangeCampaign($event, 'billing_event')"
                  v-model="edit_campaign.billing_event"
                  :value="edit_campaign.billing_event"
                  placeholder="Billing"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="edit_campaign.targeting"
                  :value="edit_campaign.targeting"
                  v-on:change="onChangeCampaign($event, 'targeting')"
                  rows=5
                  label="Targeting"
                  hint="please enter campaign targeting"
                  dense
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditCampaign=false; edit_campaign={};"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editProjectCampaignRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      header_members: [
        { text: "#", value: "memberrank", width: "10px" },
        { text: "Image", value: "memberimage", width: "10%"},
        { text: "Name", value: "membername" },
        { text: "Status", value: "memberstatus", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      header_campaigns: [
        { text: "Type", value: "campaigntype", width: "10%"},
        { text: "Campaign", value: "campaignname" },
        { text: "Objective", value: "campaignobjective", width: "20%" },
        { text: "Optimization & Billing", value: "optimization_goal", width: "20%" },
        { text: "Status", value: "campaignstatus", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      initvalue: {},
      marketproject: {},
      data_members: [],
      data_users: [],
      data_campaigns: [],
      projectcontents: [],
      projectevents: [],
      projectjobs: [],
      pages: [],
      
      
      marketprojecttype: ['Branding Project', 'Digital Project', 'Other Project'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      imageurl: undefined,
      new_campaignstartdate: null,
      new_campaignenddate: null,
      new_contentpostdate: null,
      edit_memberstartdate: null,
      edit_memberenddate: null,
      edit_campaignpostdate: null,
      new_campaignphoto: null,
      new_contentphoto: null,
      edit_memberphoto: null,
      edit_campaignphoto: null,
      photo: {},
      add_member: {},
      add_campaign: {},
      add_event: {},
      add_job: {},
      edit_member: {},
      edit_campaign: {},
      edit_event: {},
      edit_job: {},
      change_project: {},
      change_member: {},
      change_campaign: {},
      change_event: {},
      change_job: {},
      delete_member: {},
      delete_campaign: {},
      delete_event: {},
      delete_job: {},
      isDeleteMember: false,
      isDeleteCampaign: false,
      isDeleteEvent: false,
      isDeleteJob: false,
      isAddMember: false,
      isAddCampaign: false,
      isAddEvent: false,
      isAddJob: false,
      isEditMember: false,
      isEditCampaign: false,
      isEditEvent: false,
      isEditJob: false,
      footer: {'items-per-page-options': [500, 1000, 5000]},
    }
  },
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Location', ['locations']),
    ...mapState('MarketProject', ['isReceiving']),
    ...mapState('MarketPlatform', ['platforms']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('MarketProject', 
    [ 'getMarketProjectRequest','getMarketProjectsRequest',
      'updateMarketProjectRequest','updateMarketProjectImageRequest',
      'deleteProjectCampaignRequest', 'deleteProjectEventRequest',
      'insertProjectCampaignRequest',
      'updateProjectCampaignRequest','updateProjectEventRequest' 
    ]),
    ...mapActions('MarketMember', ['deleteProjectMemberRequest', 'insertProjectMemberRequest',
    'insertProjectMemberWithImageRequest', 'updateProjectMemberRequest', 'updateProjectMemberWithImageRequest']),
    ...mapActions('MarketContent', ['deleteProjectCampaignRequest', 
    'insertProjectContentWithImageRequest', 'updateProjectContentRequest', 'updateProjectContentWithImageRequest']),
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('MarketPlatform', ['getMarketPlatformsRequest']),
    ...mapActions('User', ['getUsersMarketProjectRequest']),
    Done() {
      if(this.initvalue._isFrom!==undefined) this.$router.replace({ name: this.initvalue._isFrom });
      else this.$router.replace({ name: 'MarketProjectTeamList' });
    },
    selectUser(item){
      let user = this.data_users.find(user=>user._id==item);
      this.add_member = Object.assign({}, this.add_member, {membername: user.username});
    },
    async addProjectMemberRequest() {
      this.isAddMember = false;
      this.add_member.projectid = this.initvalue._id;
      let result = await this.insertProjectMemberRequest(this.add_member);
      this.data_members.push(result);
      this.add_member = {};
    },
    async addProjectCampaignRequest() {
      this.isAddCampaign = false;
      this.add_campaign.projectid = this.initvalue._id;
      console.log(this.add_campaign)
      let result = await this.insertProjectCampaignRequest(this.add_campaign);
      this.data_campaigns.push(result);
      this.add_campaign = {};
    },
    async addProjectJobRequest() {
      this.isAddJob = false;
      this.add_job.projectid = this.initvalue._id;
      let result = await this.insertProjectJobRequest(this.add_job);
      this.projectjobs.push(result);
      this.add_job = {};
    },
    deleteProjectMemberDialog(item) {
      this.isDeleteMember = true;
      this.delete_member = { _id: item._id, membername: item.membername };
    },
    deleteProjectCampaignDialog(item) {
      this.isDeleteCampaign = true;
      this.delete_campaign = { _id: item._id, contenttitle: item.contenttitle };
    },
    deleteProjectEventDialog(item) {
      this.isDeleteEvent = true;
      this.delete_event = { _id: item._id, eventname: item.eventname };
    },
    deleteProjectJobDialog(item) {
      this.isDeleteJob = true;
      this.delete_job = { _id: item._id, jobname: item.jobname };
    },
    async deleteProjectMember(payload) {
      this.isDeleteMember = false;
      let response = await this.deleteProjectMemberRequest(payload);
      let index = this.data_members.findIndex((trans) => trans._id == response._id);
      this.data_members.splice(index, 1);
    },
    async deleteProjectCampaign(payload) {
      this.isDeleteCampaign = false;
      let response = await this.deleteProjectCampaignRequest(payload);
      let index = this.projectcontents.findIndex((trans) => trans._id == response._id);
      this.projectcontents.splice(index, 1);
    },
    async deleteProjectEvent(payload) {
      this.isDeleteEvent = false;
      let response = await this.deleteMarketProjectItemRequest(payload);
      let index = this.projectevents.findIndex((trans) => trans._id == response._id);
      this.projectevents.splice(index, 1);
    },
    async deleteProjectJob(payload) {
      this.isDeleteJob = false;
      let response = await this.deleteProjectJobRequest(payload);
      let index = this.projectjobs.findIndex((trans) => trans._id == response._id);
      this.projectjobs.splice(index, 1);
    },
    editProjectMemberDialog(item) {
      this.edit_member = Object.assign({}, item);
      this.change_member = {};
      this.isEditMember = true;
    },
    editProjectCampaignDialog(item) {
      this.edit_campaign = Object.assign({}, item);
      this.change_campaign = {};
      this.isEditCampaign = true;
    },
    async updateMarketProject() {
      this.change_project._id = this.initvalue._id;
      await this.updateMarketProjectRequest(this.change_project);
      this.getMarketProjectsRequest();
      this.Done();
    },
    async editProjectMemberRequest() {
      this.isEditMember = false;
      this.change_member.memberid = this.edit_member._id;
      let response;
      if(this.change_member.imagefile!==null && this.change_member.imagefile!==undefined) response = await this.updateProjectMemberWithImageRequest(this.change_campaign);
      else response = await this.updateProjectMemberRequest(this.change_member);
      let index = this.data_members.findIndex((x) => x._id == response._id);
      this.data_members.splice(index, 1, response);
      this.edit_member = {};
      this.edit_memberphoto = null;
    },
    async editProjectCampaignRequest() {
      this.isEditCampaign = false;
      this.change_campaign._id = this.edit_campaign._id;
      console.log(this.change_campaign)

      let response = await this.updateProjectCampaignRequest(this.change_campaign);
      let index = this.data_campaigns.findIndex((x) => x._id == response._id);
      this.data_campaigns.splice(index, 1, response);
      this.edit_campaign = {};
    },
    async editProjectEventRequest() {
      this.isEditEvent = false;
      this.change_event.marketprojectitemid = this.edit_event._id;
      let response = await this.updateProjectEventRequest(this.change_event);
      let index = this.projectevents.findIndex((x) => x._id == response._id);
      this.projectevents.splice(index, 1, response);
      this.edit_event = {};
    }, 
    async editProjectJobRequest() {
      this.isEditJob = false;
      this.change_job.marketprojectitemid = this.edit_job._id;
      let response = await this.updateProjectJobRequest(this.change_job);
      let index = this.projectjobs.findIndex((x) => x._id == response._id);
      this.projectjobs.splice(index, 1, response);
      this.edit_job = {};
    },
    editPhoto() {
      this.photo._id = this.initvalue._id;
      this.updateMarketProjectImageRequest(this.photo);
      router.push('/marketproject/list');
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => this.imageurl = e.target.result;
      reader.readAsDataURL(file);
    },  
    onFileChange(file) {
      if (!file) return;
      this.photo.imagefile = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    },
    onChangeMemberPhoto(file) {
      if (!file) return;
      this.add_member.imagefile = file;
      this.add_member.imagename = file.name;
    },
    onChangeMemberEditPhoto(file) {
      if (!file) return;
      this.change_campaign.imagefile = file;
      this.change_campaign.imagename = file.name;
    },
    onChangeProject(value, field){
      this.change_project[field] = value;
    },
    onChangeMember(value, field){
      this.change_member[field] = value;
    },
    onChangeCampaign(value, field){
      this.change_campaign[field] = value;
    },
    onChangeEvent(value, field){
      this.change_event[field] = value;
    },  
    onChangeJob(value, field){
      this.change_job[field] = value;
    },     
  },

  async created () {
    this.initvalue = this.$route.params;
    let result = await this.getMarketProjectRequest(this.initvalue._id);

    this.data_members = Object.assign([], result.members);
    this.data_campaigns = Object.assign([], result.adcampaigns);

    this.imageurl = this.initvalue.projectimage;
    if(!this.initvalue._id) this.$router.push({ name: 'MarketProjectList' });
    
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.platforms.length==0) await this.getMarketPlatformsRequest();
    this.data_users = await this.getUsersMarketProjectRequest();

    for(var platform of this.platforms){
      this.pages = [...this.pages, ...platform.pages];
    }

  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
